/** Tipos que se muestran en el centro del nav: chat del curso y avisos del muro. */
export const NAV_NOTIFICATION_TYPES = [
    'new_message',
    'reply',
    'mention',
    'teacher_notice',
    'class_live',
];

/** Se cargan de a 5; el resto llega al hacer scroll en cada pestaña. */
export const NOTIFICATIONS_PAGE_SIZE = 5;

/** Filtros del centro de notificaciones. */
export const NOTIFICATION_FILTERS = {
    unread: 'unread',
    read: 'read',
};
